import * as React from "react";
import PropTypes from "prop-types";
import {
    Tab,
    Tabs,
    Box,
    Button,
    TextField,
    Typography,
  } from "@mui/material";
import LoanUserReportTab from "../LoanUserReportTab/LoanUserReportTab";
import LoanUserDueReportTab from "../LoanUserDueReportTab/LoanUserDueReportTab";
import LoanUserAgeAnalysisTab from "../LoanUserAgeAnalysisTab/LoanUserAgeAnalysisTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const LoanUserReportsView = ({setViewReports, selectedUser}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
        <Box className="d-flex justify-content-between">
            <Typography
                sx={{
                    fontFamily: "'Nunito'",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "21.4825px",
                    color: "#3A3A3A",
                }}
                className=""
            >
                View Reports
            </Typography>
            <Button
                className="fs-size-12 paiy-blue text-white"
                variant="contained"
                color="primary"
                onClick={() => setViewReports(false)}
            >
                Return
            </Button>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
          >
              <Tab label="Loans Status" {...a11yProps(0)} />
              <Tab label="Loans Due" {...a11yProps(1)} />
              <Tab label="Age analysis" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <LoanUserReportTab selectedUser={selectedUser} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <LoanUserDueReportTab selectedUser={selectedUser} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <LoanUserAgeAnalysisTab selectedUser={selectedUser} />
        </CustomTabPanel>
    </Box>
  );
};

export default LoanUserReportsView;
